/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  awsMarketplace: {
    id: 'organization-switch.aws-marketplace',
    defaultMessage: 'Amazon Web Services marketplace',
  },
  azureMarketplace: {
    id: 'organization-switch.azure-marketplace',
    defaultMessage: 'Microsoft Azure marketplace',
  },
  gcpMarketplace: {
    id: 'organization-switch.gcp-marketplace',
    defaultMessage: 'Google Cloud marketplace',
  },
  reauthenticationRequired: {
    id: 'organization-switch.reauthentication-required',
    defaultMessage: 'Reauthentication required',
  },
  noOrganizationImageAlt: {
    id: 'manage-organizations.empty-organizations-prompt.no-organizations-illustration-alt',
    defaultMessage: 'No organizations found illustration',
  },
  noOrganizationFound: {
    id: 'manage-organizations.empty-organizations-prompt.no-organization-found',
    defaultMessage: 'No organization found',
  },
  noOrganizationDescription: {
    id: 'manage-organizations.empty-organizations-prompt.no-organization-description',
    defaultMessage: `You aren't a member of any organizations.`,
  },
  noOrganizationCta: {
    id: 'manage-organizations.empty-organizations-prompt.no-organization-cta',
    defaultMessage:
      'Create an organization to get started, or ask your organization owner to invite you.',
  },
  createOrganization: {
    id: 'manage-organizations.empty-organizations-prompt.create-organization',
    defaultMessage: 'Create organization',
  },
})
